// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.search-ia-dislike-container[data-v-28d61768] {\n  width: 100%;\n  padding: 0;\n}\n.custom-dialog-action-buttons-container[data-v-28d61768] {\n  margin-top: 16px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
